import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const gmpPostHideColumnsAPI = createApi("GMPPostHideColumns","POST");

const GMPPostHideColumns = createSlice({
  name: 'GMPPostHideColumns',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(gmpPostHideColumnsAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(gmpPostHideColumnsAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(gmpPostHideColumnsAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GMPPostHideColumns.reducer;